import _ from "lodash";

export const verificaCadastroIncompleto = (user) => {
    const temNome = !_.isNil(_.get(user, 'NOME', null));
    const temPerfil = !_.isNil(_.get(user, 'perfil', null));
    const temEndereco = !_.isNil(_.get(user, 'endereco', null));
    const isBrasil = _.get(user, 'endereco.pais', 'Brasil') === 'Brasil';
    if (!temNome || !temPerfil || !temEndereco) return true;
    const temNumero = !_.isNil(_.get(user, 'endereco.numero', null));
    const temLogradouro = !_.isNil(_.get(user, 'endereco.logradouro', null));
    const temCidade = !_.isNil(_.get(user, 'endereco.cidade', null));
    if (isBrasil && (!temCidade || !temNumero || !temLogradouro)) return true;
    const temNumeroDocumento = !_.isNil(_.get(user, 'numero_documento', null));
    if (!isBrasil && !temNumeroDocumento) return true;
    return false;
}